import { render } from "./ProductDetailPage.vue?vue&type=template&id=efbec5ba&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=efbec5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbec5ba"]])

export default __exports__